export const Envs = {
  BFF_WEB_URL: process.env['NX_BFF_WEB_URL'] ?? process.env['REACT_APP_HUB_API'],
  COOKIE_DOMAIN:
    process.env['NX_COOKIE_DOMAIN'] ??
    process.env['REACT_APP_COOKIE_DOMAIN'] ??
    process.env['NEXT_PUBLIC_COOKIE_DOMAIN'],
}
